import styled from 'styled-components';
import { rem, em } from 'polished';
import {   Paragraph, Heading } from 'elements';
import { colors } from 'core/theme';
import { media, FlexItem } from 'core/layout';
import { HeadingBase } from 'elements/Heading/styled';


export const StyledPartija = styled.p`
    font-size: ${rem(14)};
    color: ${colors.lightText};
    margin-top:0;
    margin-bottom:${rem(8)};

 ${media.tabletSmall`
    font-size: ${rem(14)};
  `};

`;

export const StyledHeading = HeadingBase.extend`
  color: currentColor;
  margin-top:${rem(8)} !important;
  margin-bottom:${rem(8)} !important;

`;
export const StyledParagraph = styled.p`
  color: currentColor;
  margin-top:${rem(8)} !important;
  margin-bottom:${rem(8)} !important;
`;
export const StyledImageDiv = styled.div`
  font-size:0;
  margin-bottom:${rem(18)} !important;
`;

export const StyledFlexItem = FlexItem.extend`
  overflow:hidden;

  img {
    width:100%;
    height:auto;
  }
  > p {
    margin-top:${rem(8)} !important;
  }

  ${media.tabletSmall`
    margin-bottom:${rem(24)} !important;
    > p {
       font-size: ${rem(14)};
    }
  `};

  @media print {
    img {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Deputati/components/Deputats/styled.js